import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { sys, chat } from '../../service'
import {
    Button,
    Avatar,
    Card,
    Modal,
    message,
    Divider,
    Input,
} from 'antd';
import {
    MessageOutlined
} from '@ant-design/icons';
import { useNavigate, useParams } from 'react-router-dom';
import ChatHistory from "../chat-history";

export default function SiteNewsView(props) {

    const { createUid } = props
        , navigate = useNavigate()
        , { serverUrl } = useSelector(state => state.siteInfo)
        , [createInfo, setCreateInfo] = useState({})
        , [openModal, setOpenModal] = useState(false)
        , [openNewsModal, setNewsModal] = useState(false)
        , [chatId, setChatId] = useState(null)
        , basic = useSelector(state => state.basic)

    useEffect(() => {
        if (createUid) {
            async function fetchData() {
                const { data } = await sys.getUserBasic(createUid)
                setCreateInfo(data)
            }
            fetchData()
        }
    }, [createUid])

    const onChatClick = async () => {
        if (basic.id) {
            if (basic.id === createUid) {
                message.warning("无法给自己发送信息！")
            } else {
                const { data } = await chat.apiChat.post({ receiverId: createUid })
                setChatId(data)
                setNewsModal(true)
            }
        } else {
            setOpenModal(true)
        }
    }

    return (
        <div className='sitenews-container'>
            <Button
                type='link'
                icon={<MessageOutlined />}
                onClick={() => onChatClick()}
            >发消息</Button>

            <ChatHistory
                chatId={chatId}
                toId={createUid}
                open={openNewsModal}
                onClose={() => setNewsModal(false)}
            />

            <Modal
                title='提示'
                open={openModal}
                onCancel={() => setOpenModal(false)}
                footer={[
                    <Button key="back" onClick={() => setOpenModal(false)}>
                        取消
                    </Button>
                ]}
            >
                <div className='m-lg' style={{ fontSize: '18px' }}>
                    该功能需要登录后才可使用，现在<span
                        style={{ color: '#44AFAD', cursor: 'pointer', margin: '0 4px' }}
                        onClick={() => navigate('/login')}
                    >去登录！</span>
                </div>
            </Modal>

        </div>
    )
}
